import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';
import { DirectivesAngularModule } from 'rev-shared/util/directives/DirectivesAngular.Module';
import { FormDirectivesAngularModule } from 'rev-shared/util/directives/form/FormDirectivesAngular.Module';
import { PushModule } from 'rev-shared/push/Push.Module';
import { SecurityAngularModule } from 'rev-shared/security/SecurityAngular.Module';
import { SecurityComponentsModule } from 'rev-shared/security/components/SecurityComponents.Module';
import { SpinnerAngularModule } from 'rev-shared/ui/spinner/SpinnerAngular.Module';
import { VbAuthLayoutModule } from 'rev-shared/ui/authLayout/VbAuthLayout.Module';

import { EmbedLoginComponent } from './EmbedLogin.Component';

@NgModule({
	declarations: [
		EmbedLoginComponent
	],
	exports: [
		EmbedLoginComponent
	],
	imports: [
		ButtonsAngularModule,
		CommonModule,
		DirectivesAngularModule,
		FormDirectivesAngularModule,
		FormsModule,
		PushModule.forRoot(true),
		SecurityAngularModule,
		SecurityComponentsModule,
		SpinnerAngularModule,
		TranslateModule,
		VbAuthLayoutModule
	]
})
export class EmbedLoginModule {}
